/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Pale_Swan_HuntInputs */

const en_happy_pale_swan_hunt = /** @type {(inputs: Happy_Pale_Swan_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All keywords`)
};

const de_happy_pale_swan_hunt = /** @type {(inputs: Happy_Pale_Swan_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Keywords`)
};

/**
* | output |
* | --- |
* | "All keywords" |
*
* @param {Happy_Pale_Swan_HuntInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_pale_swan_hunt = /** @type {((inputs?: Happy_Pale_Swan_HuntInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Pale_Swan_HuntInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_pale_swan_hunt(inputs)
	return de_happy_pale_swan_hunt(inputs)
});